import axiosActionsFactory from '../axiosHelpers';
import { getSelectedCompany } from '../../selectors';
import { UrlService } from '../../../services';
import { uuidv4 } from '../../../utils/uuid';

export const FETCH_FEATURE_TOGGLES = axiosActionsFactory('FETCH_FEATURE_TOGGLES');

export const FeatureToggle = {
  DISABLED_FLEET: 'DISABLED_FLEET',
  LOCATIONS_ENABLED: 'LOCATIONS_ENABLED',
  PREDEFINED_LOCATION_CONSENT_ENABLED: 'PREDEFINED_LOCATION_CONSENT_ENABLED',
  SHOW_LAST_TRACE: 'SHOW_LAST_TRACE',
  SEARCH_ASSETS: 'SEARCH_ASSETS',
  SHOW_GEOFENCING_WITH_ETA: 'SHOW_GEOFENCING_WITH_ETA',
  ETA_REPORTS_ENABLED: 'ETA_REPORTS_ENABLED',
  MO_AI_IMPORT: 'MO_AI_IMPORT',
  MO_CO2_EMISSION_REPORT: 'MO_CO2_EMISSION_REPORT',
  TELEMATIC_ACCOUNT_CREATE_ANYWAY_ENABLED: 'TELEMATIC_ACCOUNT_CREATE_ANYWAY_ENABLED',
};

export const fetchFeatureToggles = () => async (dispatch, getState) => {
  const state = getState();
  const contextCompanyId = getSelectedCompany(state);

  await dispatch({
    type: FETCH_FEATURE_TOGGLES.START,
    payload: {
      actionId: uuidv4(),
      request: {
        method: 'get',
        url: UrlService.featureToggles(),
        params: {
          contextCompanyId,
        },
      },
    },
  });
};
